import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Divider,
  TimePicker,
  Radio,
  Input,
  Flex,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { getStockItems } from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import { PlusOutlined } from '@ant-design/icons';
import { MdDelete } from 'react-icons/md';
import {
  addEmployee,
  getEmployeeDetails,
  updateEmployee,
} from '../../../network/employee';
import { getCountriesWithLanguages } from '../../../network/patients';
import PhoneInputWithCountrySelect, {
  parsePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input';
import AdditionalCostsList from './AdditionalCostsList';
import EducationList from './EducationList';
import HeadingApp from '../../../hooks/HeadingApp';
import { HiUserGroup } from 'react-icons/hi2';
const AddEmployee = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const formWatchPreferedContactEmail = Form.useWatch(
    'prefered_contact_email',
    form
  );
  const [dataSource, setDataSource] = useState([{}]);
  const [dataSourceEduction, setDataSourceEduction] = useState([
    {
      year_of_passing: dayjs(),
    },
  ]);
  const { id } = useParams();
  const { companyName, currentLang } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const watchsalaryMode = Form.useWatch('salary_mode', form);
  // console.log(watchsalaryMode, 'watchsalaryMode');

  const { mutate: onAddStockEntry } = useMutation({
    mutationKey: ['addStockEntry'],
    mutationFn: (body) => (edit ? updateEmployee(body, id) : addEmployee(body)),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getEmployee] });
      form.resetFields();
      navigate('/employee');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);;
      console.log('error:', error);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { data: employeeDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getEmployee, id],
    queryFn: () => getEmployeeDetails(id),
    enabled: !!edit,
  });
  // const { data: countries } = useQuery({
  //   queryKey: [queryKeys.countriesWithLanguages, currentLang],
  //   queryFn: () => getCountriesWithLanguages(currentLang),
  //   keepPreviousData: true,
  // });
  const { data: userData } = useQuery({
    queryKey: [queryKeys.getUserSearch],
    queryFn: () => getSearchApi('User'),
    keepPreviousData: true,
  });
  const { data: payrollcostcenter } = useQuery({
    queryKey: [queryKeys.getCostCenterSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const { data: department } = useQuery({
    queryKey: [queryKeys.getDepartmentSearch],
    queryFn: () => getSearchApi('Department'),
    keepPreviousData: true,
  });
  const { data: employmentType } = useQuery({
    queryKey: [queryKeys.getEmploymentTypeSearch],
    queryFn: () => getSearchApi('Employment Type'),
    keepPreviousData: true,
  });
  const { data: designation } = useQuery({
    queryKey: [queryKeys.getDesignationSearch],
    queryFn: () => getSearchApi('Designation'),
    keepPreviousData: true,
  });
  const { data: Employee } = useQuery({
    queryKey: [queryKeys.getEmployeeSearch],
    queryFn: () => getSearchApi('Employee'),
    keepPreviousData: true,
  });
  const { data: branch } = useQuery({
    queryKey: [queryKeys.getBranchSearch],
    queryFn: () => getSearchApi('Branch'),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (edit && employeeDetails) {
      setDataSource(employeeDetails?.data?.external_work_history);
      setDataSourceEduction(employeeDetails?.data?.education);
      form.setFieldsValue({
        ...employeeDetails?.data,
        date_of_joining: dayjs(employeeDetails?.data?.date_of_joining),
        date_of_birth: dayjs(employeeDetails?.data?.date_of_birth),
        date_of_retirement: dayjs(employeeDetails?.data?.date_of_retirement),
        contract_end_date: dayjs(employeeDetails?.data?.contract_end_date),
        valid_upto: dayjs(employeeDetails?.data?.valid_upto),
        relieving_date: dayjs(employeeDetails?.data?.relieving_date),

        custom_id_expiry_date: dayjs(
          employeeDetails?.data?.custom_id_expiry_date
        ),
        education: employeeDetails?.data?.education?.map((item) => ({
          ...item,
          year_of_passing: dayjs(item?.year_of_passing),
        })),
      });
    }
  }, [edit, employeeDetails, form]);
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddStockEntry({
      ...values,
      company: companyName,
      employee_name:
        values?.first_name +
        ' ' +
        values?.middle_name +
        ' ' +
        values?.last_name,
      custom_nationality: 'Saudi Arabia',
      create_user_permission: 1,
      date_of_joining: dayjs(values?.date_of_joining).format('YYYY-MM-DD'),
      date_of_birth: dayjs(values?.date_of_birth).format('YYYY-MM-DD'),
      date_of_retirement: dayjs(values?.date_of_retirement).format(
        'YYYY-MM-DD'
      ),
      contract_end_date: dayjs(values?.contract_end_date).format('YYYY-MM-DD'),
      valid_upto: dayjs(values?.valid_upto).format('YYYY-MM-DD'),
      custom_id_expiry_date: dayjs(values?.custom_id_expiry_date).format(
        'YYYY-MM-DD'
      ),
      relieving_date: dayjs(values?.relieving_date).format('YYYY-MM-DD'),
      // education: values?.education?.map((item) => ({
      //   ...item,
      //   year_of_passing: dayjs(item?.year_of_passing).format('YYYY'),
      // })),
      education: dataSourceEduction,
      external_work_history: dataSource,
    });
  };
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.UpdateEmployee : t.AddEmployee}
        path="/employee"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.Employees}
        subTitle={edit ? t.UpdateEmployee : t.AddEmployee}
        icon={<HiUserGroup />}
      />
      <Card
        style={{
          borderRadius: '0',
        }}
      >
        <Form
          form={form}
          name="add-employee"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            education: [{}],
            external_work_history: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                {/* <Divider orientation="left">{t.employeePersonalDetails}</Divider> */}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="first_name"
                    label={t.firstName}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.firstName} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="middle_name" label={t.middleName}>
                    <Input placeholder={t.middleName} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="last_name"
                    label={t.lastName}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.lastName} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="gender"
                    label={t.gender}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select placeholder={t.gender}>
                      <Select.Option value="Male">{t.male}</Select.Option>
                      <Select.Option value="Female">{t.female}</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col sm={12} md={8} lg={8} xxl={8}>
                  <Form.Item
                    name="cell_number"
                    label={t.phoneNumber}
                    className="w-full"
                    rules={[
                      {
                        required: true,
                      },
                      {
                        validator: (rule, value) => {
                          console.log(value, 'value');
                          if (isValidPhoneNumber(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject('رقم الجوال غير صالح');
                        },
                      },
                    ]}
                    hasFeedback
                  >
                    <PhoneInputWithCountrySelect
                      defaultCountry="SA"
                      className="w-full"
                      name="phone"
                      label={t.mobile}
                      international
                      hasFeedback
                      limitMaxLength={true}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="date_of_birth"
                    label={t.DateOfBirth}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.DateOfBirth}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="date_of_joining"
                    label={t.dateOfJoining}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs().add(1, 'days')}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.dateOfJoining}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="status"
                    label={t.status}
                    initialValue={'Active'}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select placeholder={t.status}>
                      <Select.Option value="Active">{t.active}</Select.Option>
                      <Select.Option value="Inactive">
                        {t.inactive}
                      </Select.Option>
                      <Select.Option value="Suspended">
                        {t.suspended}
                      </Select.Option>
                      <Select.Option value="Left">{t.left}</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="custom_id_number"
                    label={t.customIdNumber}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.customIdNumber} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="custom_id_expiry_date"
                    label={t.customIdExpiryDate}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.customIdExpiryDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item name="custom_nationality" label={t.CustomNationality}>
                <Select
                  placeholder={t.CustomNationality}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  options={countries?.message?.countries?.map((country) => ({
                    value: country.name,
                    label: currentLang === 'en' ? country.en : country.ar,
                  }))}
                />
              </Form.Item>
            </Col> */}

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="user_id" label={t.userId}>
                    <Select
                      placeholder={t.userId}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={userData?.message?.map((user) => ({
                        value: user?.value,
                        label: user?.description,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="marital_status" label={t.maritalStatus}>
                    <Select placeholder={t.maritalStatus}>
                      <Select.Option value="Single">Single</Select.Option>
                      <Select.Option value="Married">Married</Select.Option>
                      <Select.Option value="Widowed">Widowed</Select.Option>
                      <Select.Option value="Divorced">Divorced</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="passport_number" label={t.passportNumber}>
                    <Input placeholder={t.passportNumber} type="number" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="valid_upto"
                    label={t.ValidUpto}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.contractEndDate}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current && current < dayjs().startOf('day')
                      }
                    />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.employeeDetails}</Divider>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="department"
                    label={t.department}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.department}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={department?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employment_type"
                    label={t.employmentType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.employmentType}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={employmentType?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="designation"
                    label={t.designation}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.designation}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={designation?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="reports_to"
                    label={t.reportsTo}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.reportsTo}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={Employee?.message?.map((user) => ({
                        value: user?.value,
                        label: user?.description,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="branch"
                    label={t.branch}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.branch}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={branch?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="date_of_retirement"
                    label={t.DateOfRetirement}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    initialValue={dayjs().add(10, 'year')}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.DateOfRetirement}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current && current < dayjs().startOf('day')
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="contract_end_date"
                    label={t.contractEndDate}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    initialValue={dayjs().add(1, 'year')}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.contractEndDate}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current && current < dayjs().startOf('day')
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="expense_approver"
                    label={t.expenseApprover}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.expenseApprover}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={userData?.message?.map((user) => ({
                        value: user.value,
                        label: user.description,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="leave_approver"
                    label={t.leaveApprover}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.leaveApprover}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={userData?.message?.map((user) => ({
                        value: user.value,
                        label: user.description,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="current_address" label={t.currentAddress}>
                    <Input.TextArea
                      // autoSize={{ minRows: 4, maxRows: 5 }}
                      placeholder={t.currentAddress}
                    />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.employeeContactDetails}</Divider>
                <Col sm={12} md={8} lg={8} xxl={8}>
                  <Form.Item
                    name="prefered_contact_email"
                    label={t.PerferredContactEmail}
                  >
                    {/* <Input placeholder={t.PerferredContactEmail} type="email" /> */}
                    <Select
                      placeholder={t.PerferredContactEmail}
                      options={[
                        {
                          value: 'Company Email',
                          label: t.CompanyEmail,
                        },
                        {
                          value: 'Personal Email',
                          label: t.PersonalEmail,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                {formWatchPreferedContactEmail === 'Personal Email' && (
                  <Col sm={12} md={8} lg={8} xxl={8}>
                    <Form.Item name="personal_email" label={t.PersonalEmail}>
                      <Input placeholder={t.PersonalEmail} type="email" />
                    </Form.Item>
                  </Col>
                )}
                {formWatchPreferedContactEmail === 'Company Email' && (
                  <Col sm={12} md={8} lg={8} xxl={8}>
                    <Form.Item
                      name="company_email"
                      label={t.CompanyEmail}
                      // rules={[
                      //   {
                      //     required: true,
                      //   },
                      // ]}
                    >
                      <Input placeholder={t.CompanyEmail} type="email" />
                    </Form.Item>
                  </Col>
                )}

                <Col sm={12} md={8} lg={8} xxl={8}>
                  <Form.Item
                    name="person_to_be_contacted"
                    label={t.PersonToBeContacted}
                  >
                    <Input placeholder={t.PersonToBeContacted} />
                  </Form.Item>
                </Col>
                <Col sm={12} md={8} lg={8} xxl={8}>
                  <Form.Item
                    name="emergency_phone_number"
                    label={t.EmergencyPhoneNumber}
                    className="w-full"
                    rules={[
                      {
                        validator: (rule, value) => {
                          console.log(value, 'value');
                          if (isValidPhoneNumber(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject('رقم الجوال غير صالح');
                        },
                      },
                    ]}
                    hasFeedback
                  >
                    <PhoneInputWithCountrySelect
                      defaultCountry="SA"
                      className="w-full"
                      name="phone"
                      label={t.mobile}
                      international
                      hasFeedback
                      limitMaxLength={true}
                    />
                  </Form.Item>
                </Col>
                <Col sm={12} md={8} lg={8} xxl={8}>
                  <Form.Item name="relation" label={t.Relation}>
                    <Input placeholder={t.Relation} />
                  </Form.Item>
                </Col>

                <Divider orientation="left">{t.SalaryDetailes}</Divider>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="payroll_cost_center"
                    label={t.payrollCostCenter}
                  >
                    <Select
                      placeholder={t.payrollCostCenter}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={payrollcostcenter?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="salary_mode" label={t.SalaryMode}>
                    <Select
                      placeholder={t.SalaryMode}
                      options={[
                        {
                          value: 'Bank',
                          label: t.Bank,
                        },
                        {
                          value: 'Cash',
                          label: t.cash,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="bank_name"
                    label={t.bankName}
                    rules={[
                      {
                        required: watchsalaryMode === 'Bank' ? true : false,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t.bankName}
                      disabled={watchsalaryMode !== 'Bank' ? true : false}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="iban"
                    label={t.IBAN}
                    rules={[
                      {
                        required: watchsalaryMode === 'Bank' ? true : false,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t.IBAN}
                      disabled={watchsalaryMode !== 'Bank' ? true : false}
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left">{t.ExitDetailes}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="relieving_date"
                    label={t.relievingDate}
                    initialValue={dayjs().add(1, 'year')}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.relievingDate}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current && current < dayjs().startOf('day')
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    name="reason_for_leaving"
                    label={t.reasonForLeaving}
                  >
                    <Input.TextArea
                      // autoSize={{ minRows: 4, maxRows: 5 }}
                      placeholder={t.reasonForLeaving}
                    />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.EducationDetailes}</Divider>

                <Col span={24} className="items-form-add">
                  {/* <Form.List name="education" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <>
                        <Flex
                          key={key}
                          justify="space-between"
                          align="center"
                          gap="5px"
                          style={{
                            width: '100%',
                          }}
                        >
                          <Form.Item
                            name={[name, 'school_univ']}
                            label={t.schoolUniv}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Input placeholder={t.schoolUniv} />
                          </Form.Item>
                          <Form.Item
                            name={[name, 'qualification']}
                            label={t.qualification}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Input placeholder={t.qualification} />
                          </Form.Item>
                          <Form.Item
                            name={[name, 'level']}
                            label={t.level}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Select
                              placeholder={t.level}
                              style={{ width: '100%' }}
                            >
                              <Select.Option value="Graduate">
                                {t.Graduate}
                              </Select.Option>
                              <Select.Option value="Post Graduate">
                                {t.PostGraduate}
                              </Select.Option>
                            </Select>
                          </Form.Item>
                          <Form.Item
                            name={[name, 'year_of_passing']}
                            label={t.yearOfPassing}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                            initialValue={dayjs()}
                          >
                            <DatePicker
                              placeholder={t.yearOfPassing}
                              // format="YYYY"
                              picker="year"
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '15px',
                              margin: '0 10px',
                            }}
                          >
                            {fields.length > 1 && (
                              <Button
                                type="text"
                                onClick={() => remove(name)}
                                danger
                                icon={<MdDelete color="red" />}
                              />
                            )}
                            <Button
                              type="text"
                              onClick={() => add()}
                              icon={<PlusOutlined color="#1890ff" />}
                            />
                          </div>
                        </Flex>
                      </>
                    ))}
                  </>
                )}
              </Form.List> */}
                  <EducationList
                    setDataSourceEduction={setDataSourceEduction}
                    dataSourceEduction={dataSourceEduction}
                    t={t}
                  />
                </Col>
                <Divider orientation="left">
                  {t.AdditionalPreviousExperiences}
                </Divider>
                <Col span={24} className="items-form-add">
                  {/* <Form.List name="external_work_history" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <>
                        <Flex
                          key={key}
                          justify="space-between"
                          align="center"
                          gap="5px"
                          style={{
                            width: '100%',
                          }}
                        >
                          <Form.Item
                            name={[name, 'company_name']}
                            label={t.companyName}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Input placeholder={t.companyName} />
                          </Form.Item>
                          <Form.Item
                            name={[name, 'designation']}
                            label={t.designation}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Input placeholder={t.designation} />
                          </Form.Item>
                          <Form.Item
                            name={[name, 'salary']}
                            label={t.salary}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Input
                              placeholder={t.salary}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, 'total_experience']}
                            label={t.totalExperience}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Input
                              placeholder={t.totalExperience}
                              type="number"
                              min={0}
                            />
                          </Form.Item>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '15px',
                              margin: '0 10px',
                            }}
                          >
                            {fields.length > 1 && (
                              <Button
                                type="text"
                                onClick={() => remove(name)}
                                danger
                                icon={<MdDelete color="red" />}
                              />
                            )}
                            <Button
                              type="text"
                              onClick={() => add()}
                              icon={<PlusOutlined color="#1890ff" />}
                            />
                          </div>
                        </Flex>
                      </>
                    ))}
                  </>
                )}
              </Form.List> */}
                  <AdditionalCostsList
                    setDataSource={setDataSource}
                    dataSource={dataSource}
                    t={t}
                    form={form}
                  />
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddEmployee;
